import { Row, Col, Tooltip } from 'antd';
import React, { useState } from 'react';
import { bool, string, func } from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft, faSync } from '@fortawesome/pro-light-svg-icons';
import './style.scss';

let refreshTimeout = null;
/**
 * Header Component
 * title -> Title of the header
 * subtitle -> subtitle of the header
 * onBack -> onBack callback function which will be called after clicking back button
 * onRefresh -> onRefresh callback function which will be called after clicking refresh button
 * shouldHaveRefresh -> bool to check if refresh functionality should be here
 */
export default function Header({
  title, subtitle, onBack, onRefresh, shouldHaveRefresh,
}) {
  const [shouldSpin, setShouldSpin] = useState(false);
  const handleRefresh = () => {
    if (refreshTimeout) clearTimeout(refreshTimeout);
    setShouldSpin(true);
    onRefresh();
    refreshTimeout = setTimeout(() => {
      setShouldSpin(false);
    }, 1000);
  };
  return (
    <Row className="mapper-header">
      <Col span={2} className="">
        <FontAwesomeIcon size="lg" className="arc-color-primary arc-cursor-p" onClick={onBack} icon={faArrowLeft} />
      </Col>
      <Col span={19} className="profile-detail-item-content">
        <div className="arc-text-ellipsis">
          <p className="arc-H200 mapper-header-title arc-color-B85">{title}</p>
          <p className="arc-color-B45 arc-text-ellipsis arc-support">{subtitle}</p>
        </div>
      </Col>
      <If condition={shouldHaveRefresh}>
        <Col span={3} className="arc-text-align-r">
          <Tooltip title="Refresh List">
            <FontAwesomeIcon
              spin={shouldSpin}
              className="arc-color-primary arc-cursor-p"
              icon={faSync}
              onClick={handleRefresh}
            />
          </Tooltip>
        </Col>
      </If>
    </Row>
  );
}

Header.propTypes = {
  title: string,
  subtitle: string,
  onBack: func.isRequired,
  onRefresh: func.isRequired,
  shouldHaveRefresh: bool,
};

Header.defaultProps = {
  title: 'Select Record',
  subtitle: '',
  shouldHaveRefresh: true,
};
